// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'saleLabelHtml': '<div class="sale_banner">' + bcSfFilterConfig.label.sale + '</div>',
    'newLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.new + '</div>',
    'comingsoonLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.coming_soon + '</div>',
    'preorderLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.pre_order + '</div>',
    'reviewHtml': '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>',
    'vendorHtml': '<div class="vendor"><span itemprop="brand">{{itemVendorLabel}}</span></div>',
    'quickViewBtnHtml': '<span data-fancybox-href="#product-{{itemId}}" class="quick_shop ss-icon" data-gallery="product-{{itemId}}-gallery"><span class="icon-plus"></span></span>',
    'newRowHtml': '<br class="clear product_clear" />',

    // Grid Template
    'productGridItemHtml': '<div class="{{itemColumnNumberClass}} {{itemCollectionGroupThumbClass}} thumbnail {{itemCollectionGroupMobileClass}}" itemprop="itemListElement" itemscope itemtype="http://schema.org/Product">' +
                                '<a href="{{itemUrl}}" itemprop="url">' +
                                    '<div class="relative product_image">' +
                                        '<div class="product_container swap-' + bcSfFilterConfig.custom.collection_secondary_image + '">' +
                                           '{{itemImages}}' +
                                           '{{itemQuickViewBtn}}' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="info">' +
                                        '<span class="title" itemprop="name">{{itemTitle}}</span>' +
                                        '{{itemVendor}}' +
                                        '{{itemReview}}' +
                                        '{{itemPrice}}' +
                                    '</div>' +
                                    '{{itemSaleLabel}}' +
                                    '{{itemNewLabel}}' +
                                    '{{itemComingsoonLabel}}' +
                                    '{{itemPreorderLabel}}' +
                                '</a>' +
                                '{{itemSwatches}}' +
                            '</div>' +
                            '{{itemNewRow}}',

    // Pagination Template
    'previousHtml': '<span class="prev"><a href="{{itemUrl}}">« ' + bcSfFilterConfig.label.paginate_prev + '</a></span>',
    'nextHtml': '<span class="next"><a href="{{itemUrl}}">' + bcSfFilterConfig.label.paginate_next + ' »</a></span>',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

    // Sorting Template
    'sortingHtml': '<label class="inline">' + bcSfFilterConfig.label.sorting + '</label><select>{{sortingItems}}</select>'
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
     /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    var onSaleClass = onSale ? 'sale' : '';
    var soldOutClass = soldOut ? 'out_of_stock' : 'in_stock';

    var itemColumnNumberClass = '';
    var itemCollectionGroupThumbClass = buildItemCollectionGroupThumbClass(index, bcSfFilterConfig.custom.products_per_row);
    var itemCollectionGroupMobileClass = (index - 1) % 2 == 0 ? 'even' : 'odd';
    switch (bcSfFilterConfig.custom.products_per_row) {
        case 2: itemColumnNumberClass = bcSfFilterConfig.custom.show_sidebar ? 'six columns' : 'eight columns'; break;
        case 3: itemColumnNumberClass = bcSfFilterConfig.custom.show_sidebar ? 'four columns' : 'one-third column'; break;
        default: itemColumnNumberClass = bcSfFilterConfig.custom.show_sidebar ? 'three columns' : 'four columns'; break;
    }
    itemHtml = itemHtml.replace(/{{itemColumnNumberClass}}/g, itemColumnNumberClass);
    itemHtml = itemHtml.replace(/{{itemCollectionGroupThumbClass}}/g, itemCollectionGroupThumbClass);
    itemHtml = itemHtml.replace(/{{itemCollectionGroupMobileClass}}/g, itemCollectionGroupMobileClass);

     // Get image source
    var imageSrc = 'data-src="' + this.getFeaturedImage(images, '2048x') + '" ';
    imageSrc += 'data-srcset=" ' + this.getFeaturedImage(images, '2048x') + ' 2048w,';
    imageSrc += this.getFeaturedImage(images, '1600x') + ' 1600w,';
    imageSrc += this.getFeaturedImage(images, '1200x') + ' 1200w,';
    imageSrc += this.getFeaturedImage(images, '1000x') + ' 1000w,';
    imageSrc += this.getFeaturedImage(images, '800x') + ' 800w,';
    imageSrc += this.getFeaturedImage(images, '600x') + ' 600w,';
    imageSrc += this.getFeaturedImage(images, '400x') + ' 400w"';
    // Get Thumbnail url
    var thumbUrl = this.getFeaturedImage(images, '100x');
    // Get Flip image url
    var itemFlipImageUrl = images.length > 1 ? this.optimizeImage(images[1]['src'], '900x') : this.getFeaturedImage(images, '900x');

    // Add Thumbnail
    var product_set_width = data.featured_image.width;
    var align_height_value = '';
    if (bcSfFilterConfig.custom.align_height) {
        if (images.length > 0) {
            var collection_height = bcSfFilterConfig.custom.collection_height;
            var product_aspect_ratio = images[0]['width'] / images[0]['height'];
            product_set_width = product_aspect_ratio * collection_height;
            if (images[0]['width'] >= images[0]['height']) {
                var align_height_value = 'width: 100%; height: auto;';
            } else {
                var align_height_value = 'width: 100%;';
            }
        }
    }

    var itemImagesHtml = '';
    if(bcSfFilterConfig.custom.products_per_row == '4'){
        if(bcSfFilterConfig.custom.collection_secondary_image){            
            if(images.length > 1){
                itemImagesHtml += '<img src="' + bcSfFilterConfig.custom.loader_gif + '" data-src="' + this.getFeaturedImage(images, 'large') + '" data-src-retina="' + this.getFeaturedImage(images, 'grande') + '" alt="{{itemTitle}}" ';
                itemImagesHtml += 'onmouseover="';
                itemImagesHtml += "this.src='" + this.optimizeImage(images[1].src, 'grande') + "'";
                itemImagesHtml += '"';
                itemImagesHtml += ' onmouseout="';
                itemImagesHtml += "this.src='" + this.optimizeImage(images[0].src, 'grande') + "'";
                itemImagesHtml += '" />';
            }else{
                itemImagesHtml += '<img src="' + bcSfFilterConfig.custom.loader_gif + '" data-src="' + this.getFeaturedImage(images, 'large') + '" data-src-retina="' + this.getFeaturedImage(images, 'grande') + '" alt="{{itemTitle}}" />';
            }            
        }else{
            itemImagesHtml += '<img src="' + bcSfFilterConfig.custom.loader_gif + '" data-src="' + this.getFeaturedImage(images, 'large') + '" data-src-retina="' + this.getFeaturedImage(images, 'grande') + '" alt="{{itemTitle}}" />';
        }
    }else{
        if(bcSfFilterConfig.custom.collection_secondary_image){            
            if(images.length > 1){
                itemImagesHtml += '<img src="' + bcSfFilterConfig.custom.loader_gif + '" data-src="' + this.getFeaturedImage(images, 'grande') + '" data-src-retina="' + this.getFeaturedImage(images, '1024x1024') + '" alt="{{itemTitle}}" ';
                itemImagesHtml += 'onmouseover="';
                itemImagesHtml += "this.src='" + this.optimizeImage(images[1].src, 'grande') + "'";
                itemImagesHtml += '"';
                itemImagesHtml += ' onmouseout="';
                itemImagesHtml += "this.src='" + this.optimizeImage(images[0].src, 'grande') + "'";
              	itemImagesHtml += '" />';
            }else{
                itemImagesHtml += '<img src="' + bcSfFilterConfig.custom.loader_gif + '" data-src="' + this.getFeaturedImage(images, 'grande') + '" data-src-retina="' + this.getFeaturedImage(images, '1024x1024') + '" alt="{{itemTitle}}" />';
            }         
        }else{
            itemImagesHtml += '<img src="' + bcSfFilterConfig.custom.loader_gif + '" data-src="' + this.getFeaturedImage(images, 'grande') + '" data-src-retina="' + this.getFeaturedImage(images, '1024x1024') + '" alt="{{itemTitle}}" />';
        }
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Labels
    // Sold Out label
    var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
    // Sale label
    var itemSaleLabel = bcSfFilterConfig.custom.sale_banner_enabled && onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);
    // New, Coming soon, Pre order label
    var itemNewLabelHtml = '', itemComingsoonLabelHtml = '', itemPreorderLabelHtml = '';
    if (data.collections) {
        var newLabel = data.collections.filter(function(e) { return e.handle == 'new'; });
        itemNewLabelHtml = typeof newLabel[0] != 'undefined' ? bcSfFilterTemplate.newLabelHtml : '';

        var comingsoonLabel = data.collections.filter(function(e) { return e.handle == 'coming-soon'; });
        itemComingsoonLabelHtml = typeof comingsoonLabel[0] != 'undefined' ? bcSfFilterTemplate.comingsoonLabelHtml : '';

        var preorderLabel = data.collections.filter(function(e) { return e.handle == 'pre-order'; });
        itemPreorderLabelHtml = typeof preorderLabel[0] != 'undefined' ? bcSfFilterTemplate.preorderLabelHtml : '';
    }
    itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
    itemHtml = itemHtml.replace(/{{itemComingsoonLabel}}/g, itemComingsoonLabelHtml);
    itemHtml = itemHtml.replace(/{{itemPreorderLabel}}/g, itemPreorderLabelHtml);

    // Add Quick view button
    var itemQuickViewBtnHtml = bcSfFilterConfig.custom.quick_shop_enable ? bcSfFilterTemplate.quickViewBtnHtml : '';
    itemHtml = itemHtml.replace(/{{itemQuickViewBtn}}/g, itemQuickViewBtnHtml);

    // Add Review badge
    var itemReviewHtml = bcSfFilterConfig.custom.review_enable ? bcSfFilterTemplate.reviewHtml : '';
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = '';
    itemPriceHtml += '<span class="price ' + onSaleClass + '" itemprop="offers" itemscope itemtype="http://schema.org/Offer">';
    itemPriceHtml += '<meta itemprop="price" content="' + stripHtml(this.formatMoney(data.price_min)) + '" />';
    itemPriceHtml += '<meta itemprop="priceCurrency" content="' + bcSfFilterConfig.shop.currency + '" />';
    itemPriceHtml += '<meta itemprop="seller" content="' + bcSfFilterConfig.shop.name + '" />';
    itemPriceHtml += '<meta itemprop="availability" content="' + soldOutClass + '" />';
    itemPriceHtml += '<meta itemprop="itemCondition" content="New" />';
    if (!soldOut) {
        if (priceVaries && data.price_min > 0) {
            itemPriceHtml += '<small><em>' + bcSfFilterConfig.label.from_price + '</em></small> ';
        }
        if (data.price_min > 0) {
            itemPriceHtml += '<span>' + this.formatMoney(data.price_min) + '</span>';
        } else {
            itemPriceHtml += bcSfFilterConfig.label.free_price;
        }
    } else {
        itemPriceHtml += '<span class="sold_out">' + bcSfFilterConfig.label.sold_out +'</span>';
    }
    if (onSale) {
        itemPriceHtml += ' <span class="was_price">' + this.formatMoney(data.compare_at_price_max) + '</span>';
    }
    itemPriceHtml += '</span>';
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Color swatches
    var itemSwatchHtml = '';
    if(bcSfFilterConfig.custom.collection_swatches){
        for (var k in data.options) {
            if (data['options'][k].indexOf('color') > -1 || data['options'][k].indexOf('couleur') > -1) {
                var selectedOption = data['options'][k];
                var values = [];
                itemSwatchHtml += '<div class="collection_swatches">';
                for (var i = 0; i < data['variants'].length; i ++) {
                    var value = data['variants'][i]['option_' + selectedOption];
                    if (values.indexOf(value) == -1) {
                        values = values.join(',');
                        values += ',' + value;
                        values = values.split(',');
                        var variantImage = bcSfFilterConfig.general.no_image_url;
                        var temp = data.options_with_values.filter(function(e){ return e.name == selectedOption; });
                        if (typeof temp[0] !== 'undefined') {
                            var optionValues = temp[0]['values'].filter(function(e){ return e.title == value });
                            if (typeof optionValues[0] !== 'undefined') {
                                var imageIndex = optionValues[0]['image'];
                                if (typeof (data['images'][imageIndex]) !== 'undefined') {
                                    variantImage = data['images'][imageIndex];
                                }
                            }
                        }
                        if (variantImage !== '') {
                          	value = this.slugify(value);
                            itemSwatchHtml += '<a href="' + this.buildProductItemUrl(data) + '?variant=' + data['variants'][i]['id'] +  '" class="swatch">';
                            itemSwatchHtml += '<span data-image="' + this.optimizeImage(variantImage, '1024x1024') + '" style="background-color: ' + value + '; background-image: url(' + bcSfFilterConfig.general.asset_url.replace('bc-sf-filter.js', value + '_thumb.png') + '); background-position: center"></span>'
                            itemSwatchHtml += '</a>';
                        }
                    }
                }
                itemSwatchHtml += '</div>';
            }
        }
    }
    itemHtml = itemHtml.replace(/{{itemSwatches}}/g, itemSwatchHtml);

    // Add new row
    var itemNewRowHtml = index % bcSfFilterConfig.custom.products_per_row == 0 ? bcSfFilterTemplate.newRowHtml : '';
    itemHtml = itemHtml.replace(/{{itemNewRow}}/g, itemNewRowHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Build advanced class
function buildItemCollectionGroupThumbClass(index, productsPerRow) {
    var temp = index < productsPerRow ? index : index % productsPerRow;
    if (temp == 0) { return 'omega'; }
    else if (temp == 1) { return 'alpha'; }
    return '';
}

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Featured image
        if (data['images_info'] > 0) {
            data[k]['featured_image'] = data['images_info'][0];
        } else {
            data[k]['featured_image'] = {width: '', height: '', aspect_ratio: 0}
        }

        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        var colInfo = colData.collection;

        var breadcrumbHtml = '<span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="' + bcSfFilterConfig.shop.url + '" title="' + bcSfFilterConfig.shop.name  + '" itemprop="item"><span itemprop="name">' + bcSfFilterConfig.label.breadcrumb_home + '</span></a></span>';
        breadcrumbHtml += ' &nbsp;<span class="icon-arrow-right"></span>';
        breadcrumbHtml += ' <span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="/collections/' + colInfo.handle + '" title="{{currentCollectionTitle}}" itemprop="item"><span itemprop="name">{{currentCollectionTitle}}</span></a></span>';
        // Build Tags
        var currentTagsHtml = '';
        if (Array.isArray(bcSfFilterConfig.general.current_tags)) {
            var current_tags = bcSfFilterConfig.general.current_tags;
            for (var k in current_tags) {
                var tag = current_tags[k];
                currentTagsHtml += ' &nbsp;<span class="icon-arrow-right"></span>';
                currentTagsHtml += ' <span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="/collections/{{currentCollectionLink}}" title="' + tag + '" itemprop="item"><span itemprop="name">' + tag + '</span></a></span>';
            }
        }
        breadcrumbHtml += currentTagsHtml;
        // Build Collection Info
        breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollectionLink}}/g, '/collections/' + colInfo.handle).replace(/{{currentCollectionTitle}}/g, colInfo.title);
        // Top Pagination
        // var currentPage = parseInt(this.queryParams.page);
        // var totalPage = Math.ceil(apiData.total_product / this.queryParams.limit);
        // var topPaginationHtml = ' &nbsp;<span class="icon-arrow-right"></span> ' + (bcSfFilterConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, this.queryParams.page).replace(/{{ pages }}/g, totalPage)
        // breadcrumbHtml += topPaginationHtml;
        breadcrumbHtml += ' <span id="bc-sf-filter-top-pagination"></span>';

        jQ('.breadcrumb_text').html(breadcrumbHtml);
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {
    lazyload();
    collection.init();

    // Build content for Quick view
    jQ('.thumbnail').each(function (e) {
        var _this = this;
        var url = jQ(this).find(" > a").eq(0).attr("href");
        jQ.ajax({
            type: "GET",
            url: url + '?view=quickview',
            success: function(data){
                jQ(data).insertAfter(jQ(_this));
            }
        });
    });
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data) {
    // Add Wrapper for Product list
    if (jQ('#bc-sf-filter-products').children().hasClass('products')) {
        jQ('#bc-sf-filter-products').children().children().unwrap();
    }

    // Build Top Pagination
    var totalPage = Math.ceil(data.total_product / this.queryParams.limit);
    var topPaginationHtml = '&nbsp;<span class="icon-arrow-right"></span> ' + (bcSfFilterConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, this.queryParams.page).replace(/{{ pages }}/g, totalPage);
    jQ('#bc-sf-filter-top-pagination').html(topPaginationHtml);
};

function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};


function getCustomData(fOId) {
    var result = null; 
    switch (fOId) {
        case 'pf_opt_colors': result = bcSfFilterConfig.colors; break;
    }
    return result;
}

BCSfFilter.prototype.prepareFilterOptionData = function(data) {
    var options = getCustomData(data.filterOptionId);
    if (options !== null) {
        for (var k in data.values) {
            var fOItem = data['values'][k];
            var fOItemValue = fOItem['key'].trim();
            for (var j in options) {
                var currentOptions = options[j]['current'].split(',');
                var selectedOptions = currentOptions.filter(function(e) { return e.trim() == fOItemValue; });
                if (typeof selectedOptions[0] !== 'undefined') {
                    var mergeOption = options[j]['merge'].trim();
                    var mergeIndex = data.values.findIndex(function(e) { if (e !== undefined) return e.key == mergeOption; });

                    // Chech merge size is added to filter option array
                    // If Yes, increase doc_count
                    // If No, create it
                    for (var i in currentOptions) {
                        if (fOItem['key'].trim() == currentOptions[i].trim()) {
                            if (mergeIndex !== undefined && typeof data['values'][mergeIndex] !== 'undefined') {
                                data['values'][mergeIndex]['doc_count'] += fOItem['doc_count'];
                            } else {
                                var newValue = { key: mergeOption.trim(), doc_count: fOItem['doc_count'] };
                                data['values'].push(newValue);
                            }
                          	delete data['values'][k];
//                             if (currentOptions[i].trim() != fOItemValue)
//                                 delete data['values'][k];
                        }
                    }
                }
            }
        }
    }
    return data;
};

BCSfFilter.prototype.onChangeData = function(url, type, fOValue, fOId) {
    if (type != undefined && fOValue != undefined && fOId != undefined) {
        var selectedCurrent = '';
        var selectedOption = '';
        var subString = '';
        var options = getCustomData(fOId);
        if (options !== null) {
            var selectedCurrent = options.filter(function(e) { return e.merge == fOValue; });
            if (typeof selectedCurrent[0] !== 'undefined') {
                var selectedArr = selectedCurrent[0]['current'].split(',');
                for (var k in selectedArr) {
                    var selectedValue = type == 'tag' ? selectedOption + selectedArr[k].trim() : selectedArr[k].trim();
                    subString += '&' + fOId + '=' + encodeURIParamValue(selectedValue);
                }
                var mainParam = '&' + fOId + '=' + encodeURIParamValue(fOValue) + '&';
                if ((url + '&').indexOf(mainParam) == -1) {
                    url = url.replace(subString, '');
                } else {
                    url = url + subString;
                }
            }
        }
    }
    this.updateApiParams(url);
    this.getFilterData(type);
    this.changeAddressBar(url, type, fOValue);
};
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
